import React from "react"
import NumerableIconButton from "../../NumerableIconButton"
import { JARGON, LAYOUT, LINKS } from "../../../modules/constants"
import WebIcon from "@mui/icons-material/Web"

const getbuttonProps = ({ label, link, paddingLeft = LAYOUT.COLUMN_PADDING, externalLinks, page = null }) => {

    const tipEnabled = `external link to ${page ?? label} page on Companies House`
    return {
        disabled: !link || !externalLinks,
        icon: <WebIcon />,
        handleClick: () => window.open(`${LINKS.COMPANIES_HOUSE}/company/${link}`, "_blank"),
        label,
        paddingLeft,
        tipDisabled: tipEnabled + JARGON.SUBSCRIBED_USERS_ONLY,
        tipEnabled,
        fontWeight: "normal",
    }
}

function CompaniesHouseMenu(props) {
    // console.log('CompaniesHouseMenu  props:', props)
    const { companyNumber, externalLinks, portrait } = props

    const buttonProps = {
        overview: getbuttonProps({ label: "Companies House", link: companyNumber, paddingLeft: LAYOUT.MENU_FIRST_PADDING, externalLinks, page: "Overview" }),
        people: getbuttonProps({ label: "People", link: `${companyNumber}/officers`, externalLinks }),
        // pscs: getbuttonProps({ label: "PSCs", link: `${companyNumber}/persons-with-significant-control` }),
        // filingHistory: getbuttonProps({ label: "Filing History", link: `${companyNumber}/filing-history` }),
        // charges: getbuttonProps({ label: "Charges", link: `${companyNumber}/charges` }),
    }

    return (
        <div>
            <React.Fragment>
                <NumerableIconButton item={buttonProps.overview} portrait={portrait} />
                <NumerableIconButton item={buttonProps.people} portrait={portrait} />
            </React.Fragment>
        </div>
    )
}

export default CompaniesHouseMenu

